/* Blusafe Australia — G5 Wi-Fi Gateway interactive manual data.
   Rendered by au-manual-engine.js (see sections/au-g5-gateway-manual.liquid).
   Guide content: September 2026 source manual. Illustrations: au-manual-g5-*.webp. */
window.G5_GATEWAY_MANUAL_DATA = {
  "manual": {
    "title": "G5 Wi-Fi Gateway Setup and Troubleshooting Manual",
    "product_family": "G5 Wi-Fi Gateway",
    "manual_version": "V2026.1",
    "source_edition": "September 2026 source manual",
    "primary_app": "TTLock",
    "install_time_estimate": "10–15 minutes",
    "lead": "Power up your G5 dual-band gateway, read its LED, bind it to your TTLock lock over 2.4 GHz or 5 GHz Wi-Fi so you can unlock remotely, and fix the most common binding and network problems — without opening the PDF.",
    "app_links": {
      "android_google_play": "https://play.google.com/store/apps/details?id=com.tongtongsuo.app",
      "ios_app_store": "https://apps.apple.com/app/ttlock/id1033046018"
    },
    "compatible_apps": {
      "TTLock (recommended)": {
        "android": "https://play.google.com/store/apps/details?id=com.tongtongsuo.app",
        "ios": "https://apps.apple.com/app/ttlock/id1033046018"
      }
    },
    "critical_warnings": [
      "Add your Blusafe TTLock lock to the app before you add the gateway.",
      "Connect your phone to the same Wi-Fi network you want the gateway to use.",
      "Have the Wi-Fi password ready — it is case-sensitive.",
      "Place the gateway within Bluetooth range of the lock and Wi-Fi range of the router.",
      "Wait for the red and blue alternating flash before you tap Next."
    ]
  },
  "guides": [
    {
      "handle": "g5-01",
      "title": "Understand the LED indicator",
      "category": "Preparation",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Understand the meaning of G5 Gateway indicator light statuses to monitor device operation and troubleshoot connectivity issues.",
      "images": [
        {
          "src": "au-manual-g5-01-1.webp",
          "alt": "Indicator light status — Indicator Light Status Description"
        }
      ],
      "notes": [
        "Red and Blue Flashing Alternately: Ready state. The gateway is available to be added and bound by the TTLock app.",
        "Red Flashing: Poor network connection. The gateway cannot communicate with the server. Check Wi-Fi signal strength and internet connectivity.",
        "Blue Flashing: Normal working state. The gateway is operational but cannot be bound (already paired or in normal mode)."
      ],
      "warnings": [
        "If the red indicator flashes continuously, the gateway has poor network connection and cannot communicate with the server. Check your Wi-Fi router and internet connection before proceeding with device setup."
      ],
      "tips": [],
      "steps": [
        "Power on the G5 Gateway by connecting it to a power supply.",
        "Observe the indicator light behaviour during startup.",
        "Identify the current status based on the light pattern described below.",
        "Take appropriate action based on the identified status."
      ],
      "expected_result": "You can correctly identify the gateway status from the indicator light pattern and take appropriate troubleshooting actions if needed.",
      "common_mistakes": [
        "Ignoring continuous red flashing - Indicates network failure; device will not function properly without server connection.",
        "Attempting to bind when blue light is flashing - Blue flashing means the gateway is already in normal working state and cannot be bound again.",
        "Not waiting for red-blue alternating flash before binding - Binding must be initiated only when the gateway is in ready state (red-blue alternating)."
      ]
    },
    {
      "handle": "g5-02",
      "title": "Bind the gateway to the TTLock app",
      "category": "App setup",
      "estimated_time": "5–10 minutes",
      "difficulty": "Easy",
      "summary": "Bind the G5 Gateway to the TTLock app to enable remote control and monitoring of connected smart locks.",
      "images": [
        {
          "src": "au-manual-g5-02-1.webp",
          "alt": "Bind the gateway to the app — Gateway Binding to app"
        }
      ],
      "notes": [
        "Both 2.4 GHz and 5 GHz Wi-Fi networks are supported. Ensure your smartphone is connected to the same Wi-Fi network you intend to use for the gateway."
      ],
      "warnings": [
        "The gateway must be in ready state (red and blue indicators flashing alternately) before binding. If the indicator shows a different pattern, unbind and delete the gateway from the TTLock app first, then power cycle the device to enter ready state."
      ],
      "tips": [],
      "steps": [
        "Connect the G5 Gateway to a power supply using the provided adapter.",
        "Open the \"TTLock\" app on your smartphone.",
        "Tap the \"+\" button in the top-right corner of the app home screen.",
        "Select \"G5 (Wi-Fi)\" from the device list.",
        "Confirm the gateway indicator is flashing red and blue alternately, then tap \"Next\".",
        "When the G5 device appears on screen, tap \"+\" to begin pairing.",
        "Tap \"Wi-Fi Name\" and select an available Wi-Fi network from the list.",
        "Enter the Wi-Fi password carefully (case-sensitive).",
        "Enter a descriptive Gateway Name for easy identification.",
        "Tap \"OK\" to complete the binding process.",
        "Wait for the gateway to automatically search and connect to devices already bound to your app account."
      ],
      "expected_result": "The G5 Gateway is successfully bound to your TTLock app account and displays as online. Connected smart locks appear in the device list and can be controlled remotely.",
      "common_mistakes": [
        "Entering incorrect Wi-Fi password - Binding will fail; double-check password capitalisation and special characters before submitting.",
        "Not waiting for red-blue alternating flash before starting binding - Gateway must be in ready state; unbind from app and power cycle if indicator shows solid blue or continuous red.",
        "Skipping the gateway naming step - Without a descriptive name, identifying multiple gateways becomes difficult in large installations.",
        "Attempting to bind while gateway is already paired - Blue flashing indicates normal working state; unbind and delete from app before re-binding."
      ],
      "app_links": true
    },
    {
      "handle": "g5-03",
      "title": "Delete the gateway",
      "category": "Management",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Remove the G5 Gateway from your TTLock app account when replacing, relocating, or decommissioning the device.",
      "images": [
        {
          "src": "au-manual-g5-03-1.webp",
          "alt": "Delete the gateway — Delete Gateway"
        }
      ],
      "notes": [],
      "warnings": [
        "Deleting the gateway will disconnect all associated smart locks from remote access. Ensure you have alternative access methods (physical keys, local Bluetooth) before proceeding with deletion."
      ],
      "tips": [],
      "steps": [
        "Open the TTLock app and navigate to the device list.",
        "Select the G5 Gateway you wish to delete from the list.",
        "Tap the settings or options menu for the selected gateway.",
        "Tap \"Delete\" to initiate the removal process.",
        "Confirm the deletion when prompted by the confirmation dialog.",
        "Wait for the app to complete the deletion process and remove the gateway from your account."
      ],
      "expected_result": "The G5 Gateway is removed from your TTLock app account and no longer appears in the device list. Associated smart locks revert to local-only operation (Bluetooth range).",
      "common_mistakes": [
        "Deleting gateway without verifying alternative access - You may lose remote control capability; ensure physical keys or local Bluetooth access is available.",
        "Not informing other users before deletion - Shared access users will lose connectivity; notify all authorised users before removing the gateway.",
        "Confusing gateway deletion with lock unbinding - Deleting the gateway does not unbind individual locks; locks remain bound to your account but lose remote access."
      ]
    }
  ],
  "troubleshooting": [
    {
      "handle": "g5-wont-bind",
      "title": "Gateway won't add or bind in the app",
      "category": "App setup",
      "priority": "high",
      "explanation": "Binding only works while the gateway is in its ready state (red and blue alternating flash). A gateway that is already bound flashes blue and will not appear again until it is deleted from the account it belongs to. A wrong password fails the Wi-Fi step even when the gateway was found.",
      "symptoms": [
        "The G5 never appears in the search list after you tap Next.",
        "Binding starts but fails at the Wi-Fi step.",
        "The app times out while the gateway is still flashing."
      ],
      "quick_checks": [
        "The LED is flashing red and blue alternately — not blue flashing or red flashing.",
        "You chose \"G5 (Wi-Fi)\" from the device list.",
        "Your phone is on the same Wi-Fi network you selected for the gateway.",
        "The password is typed with the right capitalisation and special characters.",
        "Bluetooth is on and your phone is next to the gateway."
      ],
      "likely_causes": [
        "The gateway is already bound (blue flashing) to this or another account.",
        "A mistyped Wi-Fi password.",
        "The phone was on a different network from the one selected.",
        "The gateway is too far from the router."
      ],
      "fix_steps": [
        "If the LED is not alternating, delete the gateway from the TTLock app if it is listed, then unplug it, wait 10 seconds and plug it back in.",
        "In the app tap +, choose \"G5 (Wi-Fi)\", tap Next as soon as the LED is alternating, then tap + next to the G5 when it appears.",
        "Select the Wi-Fi network your phone is connected to and re-type the password carefully.",
        "Give the gateway a name and tap OK, then wait while it searches for your locks."
      ],
      "related_guides": [
        "g5-01",
        "g5-02",
        "g5-03"
      ],
      "support_evidence": [
        "A short video of the LED after power-up",
        "A screenshot of the Wi-Fi step in the app",
        "Router make/model"
      ],
      "app_links": false
    },
    {
      "handle": "g5-red-flashing",
      "title": "LED flashes red — gateway shows offline",
      "category": "Network",
      "priority": "high",
      "explanation": "Red flashing means the gateway cannot reach the TTLock server. The gateway is bound, but its Wi-Fi or internet path is broken — usually a router change, a weak signal or an internet outage.",
      "symptoms": [
        "The gateway LED flashes red continuously.",
        "The gateway shows as offline in the app.",
        "Remote unlock fails with a network error."
      ],
      "quick_checks": [
        "Other devices on the same Wi-Fi can reach the internet.",
        "The router name or password has not been changed since binding.",
        "The gateway is within good range of the router — not behind thick walls or metal."
      ],
      "likely_causes": [
        "Internet outage or router restart.",
        "Wi-Fi password or network name changed.",
        "Weak signal at the gateway position."
      ],
      "fix_steps": [
        "Restart the router and wait two minutes.",
        "Unplug the gateway, wait 10 seconds and plug it back in — blue flashing means it is back online.",
        "If the Wi-Fi details changed, delete the gateway from the app and bind it again with the new details.",
        "Move the gateway closer to the router or away from interference and retest."
      ],
      "related_guides": [
        "g5-01",
        "g5-02"
      ],
      "support_evidence": [
        "A short video of the LED",
        "Whether the router or Wi-Fi password changed recently",
        "Distance and obstacles between gateway and router"
      ],
      "app_links": false
    },
    {
      "handle": "g5-not-ready",
      "title": "LED never shows the red and blue alternating flash",
      "category": "App setup",
      "priority": "medium",
      "explanation": "The alternating flash is the ready state. If the gateway powers up straight into blue flashing it is already bound; if it flashes red it is bound but offline. Either way it must be unbound and restarted before it can be added again.",
      "symptoms": [
        "The LED goes straight to blue flashing after power-up.",
        "The app cannot find the gateway when you tap Next."
      ],
      "quick_checks": [
        "You did not already add this gateway under a different login.",
        "The gateway did not come from another installation or a previous owner."
      ],
      "likely_causes": [
        "The gateway is bound to your own account already.",
        "The gateway is bound to someone else's account."
      ],
      "fix_steps": [
        "Open the TTLock app and check your device list for the gateway — if it is there, it is already set up.",
        "To move it to a new account, select the gateway in the app, tap Delete and confirm.",
        "Unplug the gateway, wait 10 seconds and plug it back in — it restarts in the alternating ready state.",
        "If it belonged to someone else and they cannot delete it, contact Blusafe Australia with proof of purchase."
      ],
      "related_guides": [
        "g5-01",
        "g5-03"
      ],
      "support_evidence": [
        "Proof of purchase",
        "A photo of the label on the underside of the gateway"
      ],
      "app_links": false
    },
    {
      "handle": "g5-remote-unlock",
      "title": "Gateway is online but remote unlock does not work",
      "category": "Everyday use",
      "priority": "medium",
      "explanation": "After binding, the gateway automatically searches for locks already in your app and connects to those within Bluetooth range. If the lock is too far from the gateway, or remote unlock is switched off in the lock settings, remote commands fail even though the gateway is online.",
      "symptoms": [
        "The gateway shows online but the lock still shows as not connected.",
        "Remote unlock times out or reports failure."
      ],
      "quick_checks": [
        "The lock is added to the same TTLock account as the gateway.",
        "The gateway is within Bluetooth range of the lock — ideally in the same room.",
        "Remote Unlock is enabled in the lock's Settings in the app.",
        "The lock's batteries are not low."
      ],
      "likely_causes": [
        "Gateway placed too far from the lock.",
        "Remote unlock disabled in the lock settings.",
        "The lock was added to the app after the gateway searched — it has not connected yet."
      ],
      "fix_steps": [
        "Move the gateway nearer the lock and wait a minute for it to connect.",
        "In the app open the lock, tap Settings and turn on Remote Unlock if it is off.",
        "Power cycle the gateway so it searches for locks again.",
        "If it still fails, delete and re-bind the gateway."
      ],
      "related_guides": [
        "g5-02"
      ],
      "support_evidence": [
        "A screenshot of the gateway page showing connected locks",
        "Distance between the gateway and the lock"
      ],
      "app_links": false
    },
    {
      "handle": "g5-deleted-lost-remote",
      "title": "I deleted the gateway and my locks lost remote access",
      "category": "Management",
      "priority": "low",
      "explanation": "This is expected. Deleting the gateway removes the Wi-Fi link for every lock it served, but the locks stay in your account and still work locally over Bluetooth. Re-binding the gateway restores remote access.",
      "symptoms": [
        "Locks show as offline or Bluetooth-only after the gateway was removed.",
        "Shared users report remote unlock has stopped."
      ],
      "quick_checks": [
        "The locks are still listed in the app and unlock over Bluetooth when you are at the door."
      ],
      "likely_causes": [
        "The gateway was deleted, moved or unplugged."
      ],
      "fix_steps": [
        "Power cycle the gateway and wait for the alternating flash.",
        "Bind the gateway again following the setup guide; it reconnects to the locks automatically.",
        "Tell shared users remote access is back."
      ],
      "related_guides": [
        "g5-02",
        "g5-03"
      ],
      "support_evidence": [
        "A screenshot of the lock page showing its connection status"
      ],
      "app_links": false
    }
  ],
  "videos": [],
  "support_templates": [
    {
      "title": "Gateway won't bind",
      "subject": "G5 Wi-Fi Gateway - will not bind to the TTLock app",
      "body": "Hi Blusafe team,\n\nMy G5 Wi-Fi Gateway will not bind to the TTLock app. Here are my details:\n\nOrder number: \nLock the gateway is meant to connect to: \nLED pattern after power-up (red/blue alternating, red flashing, blue flashing): \nWi-Fi network chosen and whether my phone was on the same network: \nRouter make/model: \n\nI have attached:\n- A short video of the gateway LED\n- A screenshot of the step where the app fails\n\nThanks,\n[Your name]"
    },
    {
      "title": "Gateway keeps going offline",
      "subject": "G5 Wi-Fi Gateway - shows offline / red flashing",
      "body": "Hi Blusafe team,\n\nMy G5 Wi-Fi Gateway keeps showing offline. Here are my details:\n\nOrder number: \nLED pattern (red flashing / other): \nHow often it drops offline: \nWhether the router or Wi-Fi password changed recently: \nDistance and obstacles between the gateway and the router: \n\nThanks,\n[Your name]"
    }
  ],
  "support_evidence_default": [
    "Order number and which app you used (TTLock)",
    "Which lock the gateway is meant to connect to",
    "Which Wi-Fi network you chose and whether the phone was on the same network",
    "A short video of the gateway LED after it powers up",
    "A screenshot of the gateway page in the app"
  ],
  "search_index": [
    {
      "title": "G5 Wi-Fi Gateway Setup and Troubleshooting Manual",
      "type": "manual",
      "category": "Overview",
      "anchor": "osp-top",
      "summary": "Power up your G5 dual-band gateway, read its LED, bind it to your TTLock lock over 2.4 GHz or 5 GHz Wi-Fi so you can unlock remotely, and fix the most common binding and network problems — without opening the PDF.",
      "keywords": "g5 gateway wi-fi bridge hub dual band ttlock remote unlock bind pair led red flashing blue flashing alternating 2.4 ghz 5 ghz delete"
    },
    {
      "title": "Understand the LED indicator",
      "type": "guide",
      "category": "Preparation",
      "anchor": "g5-01",
      "summary": "Understand the meaning of G5 Gateway indicator light statuses to monitor device operation and troubleshoot connectivity issues.",
      "keywords": "Power on the G5 Gateway by connecting it to a power supply. Observe the indicator light behaviour during startup. Identify the current status based on the light pattern described below. Take appropriate action based on the identified status. Red and Blue Flashing Alternately: Ready state. The gateway is available to be added and bound by the TTLock app. Red Flashing: Poor network connection. The gateway cannot communicate with the server. Check Wi-Fi signal strength and internet connectivity. Blue Flashing: Normal working state. The gateway is operational but cannot be bound (already paired or in normal mode). If the red indicator flashes continuously, the gateway has poor network connection and cannot communicate with the server. Check your Wi-Fi router and internet connection before proceeding with device setup. Ignoring continuous red flashing - Indicates network failure; device will not function properly without server connection. Attempting to bind when blue light is flashing - Blue flashing means the gateway is already in normal working state and cannot be bound again. Not waiting for red-blue alternating flash before binding - Binding must be initiated only when the gateway is in ready state (red-blue alternating)."
    },
    {
      "title": "Bind the gateway to the TTLock app",
      "type": "guide",
      "category": "App setup",
      "anchor": "g5-02",
      "summary": "Bind the G5 Gateway to the TTLock app to enable remote control and monitoring of connected smart locks.",
      "keywords": "Connect the G5 Gateway to a power supply using the provided adapter. Open the \"TTLock\" app on your smartphone. Tap the \"+\" button in the top-right corner of the app home screen. Select \"G5 (Wi-Fi)\" from the device list. Confirm the gateway indicator is flashing red and blue alternately, then tap \"Next\". When the G5 device appears on screen, tap \"+\" to begin pairing. Tap \"Wi-Fi Name\" and select an available Wi-Fi network from the list. Enter the Wi-Fi password carefully (case-sensitive). Enter a descriptive Gateway Name for easy identification. Tap \"OK\" to complete the binding process. Wait for the gateway to automatically search and connect to devices already bound to your app account. Both 2.4 GHz and 5 GHz Wi-Fi networks are supported. Ensure your smartphone is connected to the same Wi-Fi network you intend to use for the gateway. The gateway must be in ready state (red and blue indicators flashing alternately) before binding. If the indicator shows a different pattern, unbind and delete the gateway from the TTLock app first, then power cycle the device to enter ready state. Entering incorrect Wi-Fi password - Binding will fail; double-check password capitalisation and special characters before submitting. Not waiting for red-blue alternating flash before starting binding - Gateway must be in ready state; unbind from app and power cycle if indicator shows solid blue or continuous red. Skipping the gateway naming step - Without a descriptive name, identifying multiple gateways becomes difficult in large installations. Attempting to bind while gateway is already paired - Blue flashing indicates normal working state; unbind and delete from app before re-binding."
    },
    {
      "title": "Delete the gateway",
      "type": "guide",
      "category": "Management",
      "anchor": "g5-03",
      "summary": "Remove the G5 Gateway from your TTLock app account when replacing, relocating, or decommissioning the device.",
      "keywords": "Open the TTLock app and navigate to the device list. Select the G5 Gateway you wish to delete from the list. Tap the settings or options menu for the selected gateway. Tap \"Delete\" to initiate the removal process. Confirm the deletion when prompted by the confirmation dialog. Wait for the app to complete the deletion process and remove the gateway from your account. Deleting the gateway will disconnect all associated smart locks from remote access. Ensure you have alternative access methods (physical keys, local Bluetooth) before proceeding with deletion. Deleting gateway without verifying alternative access - You may lose remote control capability; ensure physical keys or local Bluetooth access is available. Not informing other users before deletion - Shared access users will lose connectivity; notify all authorised users before removing the gateway. Confusing gateway deletion with lock unbinding - Deleting the gateway does not unbind individual locks; locks remain bound to your account but lose remote access."
    },
    {
      "title": "Gateway won't add or bind in the app",
      "type": "troubleshooting",
      "category": "App setup",
      "anchor": "g5-wont-bind",
      "summary": "The G5 never appears in the search list after you tap Next.",
      "keywords": "The G5 never appears in the search list after you tap Next. Binding starts but fails at the Wi-Fi step. The app times out while the gateway is still flashing. The gateway is already bound (blue flashing) to this or another account. A mistyped Wi-Fi password. The phone was on a different network from the one selected. The gateway is too far from the router. If the LED is not alternating, delete the gateway from the TTLock app if it is listed, then unplug it, wait 10 seconds and plug it back in. In the app tap +, choose \"G5 (Wi-Fi)\", tap Next as soon as the LED is alternating, then tap + next to the G5 when it appears. Select the Wi-Fi network your phone is connected to and re-type the password carefully. Give the gateway a name and tap OK, then wait while it searches for your locks. Binding only works while the gateway is in its ready state (red and blue alternating flash). A gateway that is already bound flashes blue and will not appear again until it is deleted from the account it belongs to. A wrong password fails the Wi-Fi step even when the gateway was found."
    },
    {
      "title": "LED flashes red — gateway shows offline",
      "type": "troubleshooting",
      "category": "Network",
      "anchor": "g5-red-flashing",
      "summary": "The gateway LED flashes red continuously.",
      "keywords": "The gateway LED flashes red continuously. The gateway shows as offline in the app. Remote unlock fails with a network error. Internet outage or router restart. Wi-Fi password or network name changed. Weak signal at the gateway position. Restart the router and wait two minutes. Unplug the gateway, wait 10 seconds and plug it back in — blue flashing means it is back online. If the Wi-Fi details changed, delete the gateway from the app and bind it again with the new details. Move the gateway closer to the router or away from interference and retest. Red flashing means the gateway cannot reach the TTLock server. The gateway is bound, but its Wi-Fi or internet path is broken — usually a router change, a weak signal or an internet outage."
    },
    {
      "title": "LED never shows the red and blue alternating flash",
      "type": "troubleshooting",
      "category": "App setup",
      "anchor": "g5-not-ready",
      "summary": "The LED goes straight to blue flashing after power-up.",
      "keywords": "The LED goes straight to blue flashing after power-up. The app cannot find the gateway when you tap Next. The gateway is bound to your own account already. The gateway is bound to someone else's account. Open the TTLock app and check your device list for the gateway — if it is there, it is already set up. To move it to a new account, select the gateway in the app, tap Delete and confirm. Unplug the gateway, wait 10 seconds and plug it back in — it restarts in the alternating ready state. If it belonged to someone else and they cannot delete it, contact Blusafe Australia with proof of purchase. The alternating flash is the ready state. If the gateway powers up straight into blue flashing it is already bound; if it flashes red it is bound but offline. Either way it must be unbound and restarted before it can be added again."
    },
    {
      "title": "Gateway is online but remote unlock does not work",
      "type": "troubleshooting",
      "category": "Everyday use",
      "anchor": "g5-remote-unlock",
      "summary": "The gateway shows online but the lock still shows as not connected.",
      "keywords": "The gateway shows online but the lock still shows as not connected. Remote unlock times out or reports failure. Gateway placed too far from the lock. Remote unlock disabled in the lock settings. The lock was added to the app after the gateway searched — it has not connected yet. Move the gateway nearer the lock and wait a minute for it to connect. In the app open the lock, tap Settings and turn on Remote Unlock if it is off. Power cycle the gateway so it searches for locks again. If it still fails, delete and re-bind the gateway. After binding, the gateway automatically searches for locks already in your app and connects to those within Bluetooth range. If the lock is too far from the gateway, or remote unlock is switched off in the lock settings, remote commands fail even though the gateway is online."
    },
    {
      "title": "I deleted the gateway and my locks lost remote access",
      "type": "troubleshooting",
      "category": "Management",
      "anchor": "g5-deleted-lost-remote",
      "summary": "Locks show as offline or Bluetooth-only after the gateway was removed.",
      "keywords": "Locks show as offline or Bluetooth-only after the gateway was removed. Shared users report remote unlock has stopped. The gateway was deleted, moved or unplugged. Power cycle the gateway and wait for the alternating flash. Bind the gateway again following the setup guide; it reconnects to the locks automatically. Tell shared users remote access is back. This is expected. Deleting the gateway removes the Wi-Fi link for every lock it served, but the locks stay in your account and still work locally over Bluetooth. Re-binding the gateway restores remote access."
    }
  ],
  "support_email": ""
};
